package pl.finn.forms.podpp

import io.kvision.form.text.TomTypeahead
import io.kvision.form.upload.UploadInput
import io.kvision.html.Button
import io.kvision.modal.Confirm
import io.kvision.redux.createReduxStore
import io.kvision.utils.getContent
import kotlinx.browser.window
import kotlinx.coroutines.CoroutineScope
import kotlinx.coroutines.Dispatchers
import kotlinx.coroutines.SupervisorJob
import pl.finn.forms.*
import pl.finn.forms.teryt.TerytApiService


object Model : CoroutineScope by CoroutineScope(Dispatchers.Default + SupervisorJob())  {

    val formsService = FormsService()
    val podppService = PodppService()
    val terytApiService = TerytApiService()

    val formularzStore =
            createReduxStore(
                    ::formularzReducer,
                    Formularz(FormularzWidok.PUSTY)
            )

    fun nowy(token: String, app: App) {
        launchWithProgress {
            val formData = podppService.nowy(token)
            formularzStore.dispatch(FormularzAction.Nowy(formData))
            app.aktywujPodpp()
            window.scrollTo(0.0, 0.0)
        }
    }


    fun sprawdz() {
        val state = Model.formularzStore.getState()
        launchWithProgress {
            val res = podppService.sprawdz(state.form!!, state.zalaczniki ?: emptyList(), state.token!!)
            println(res)
        }
    }

    fun zapisz(form: PodppForm, validateResult: String?) {
        if(validateResult == null){
            launchWithProgress {
                val state = formularzStore.getState()
                val url = podppService.zapisz(form, state.zalaczniki ?: emptyList(), validateResult, state.token!!)
                window.location.href = url
            }
        } else {
            sprawdz()
        }
    }

    fun podglad(form: PodppForm, button: Button) {
        launchWithProgress {
            val state = formularzStore.getState()
            val xml = podppService.podglad(form, state.zalaczniki ?: emptyList(), state.token!!)
            PodgladWindow(state.token).pokazTresc(xml, button)
        }
    }

    fun edycja(token: String, app: App) {
        launchWithProgress {
            val formData = podppService.edycja(token)
            formularzStore.dispatch(FormularzAction.Edycja(formData))
            app.aktywujPodpp()
            window.scrollTo(0.0, 0.0)
        }
    }

    fun anuluj() {
        launchWithProgress {
            val state = formularzStore.getState()
            val url = formsService.anuluj(state.token!!)
            window.location.href = url
        }
    }

    fun dodajZalacznik(zalacznik: UploadInput, opisZalacznika: String?, form: PodppForm) {
        launchWithProgress {
            zalacznik.value?.firstOrNull()?.let {
                val dataContent = zalacznik.getNativeFile(it)?.getContent()
                val parts = dataContent?.split(",")
                val mime = parts?.get(0)?.drop(5)?.dropLast(7)
                val content = parts?.getOrNull(1)
                Model.formularzStore.dispatch(
                  FormularzAction.DodajZalacznik(
                    Zalacznik(
                      it.name,
                      opisZalacznika,
                      mime,
                      content
                    ), form
                  )
                )
            }
        }
    }

    fun usunZalacznik(nazwa: String, form: PodppForm) {
        Confirm.show(
          "Potwierdzenie",
          "Czy na pewno usunąć wybrany załącznik?",
          yesTitle = "Tak",
          noTitle = "Nie"
        ) {
            formularzStore.dispatch(FormularzAction.UsunZalacznik(nazwa, form))
        }
    }


    fun onEditPostalCodeRefresh(postalCode: String?, officeSelect: TomTypeahead, localitySelect: TomTypeahead, streetSelect: TomTypeahead ) {
        //poczty
        //miejscowosci
        //ulice
        launchWithProgress {
            val officeList: ArrayList<String> = arrayListOf()
            val localicityList: ArrayList<String> = arrayListOf()
            val streetList: ArrayList<String> = arrayListOf()
            val result = terytApiService.addresses(postalCode)
            if(!result.addresses.isEmpty()) {
                officeSelect.removeAll()
                localitySelect.removeAll()
                streetSelect.removeAll()
                for (address in result.addresses) {
                    addToSelect(officeList, address.office)
                    addToSelect(localicityList, address.locality)
                    addToSelect(streetList, address.street)
                }
                officeSelect.options = officeList
                localitySelect.options = localicityList
                streetSelect.options = streetList
            }
        }
    }

    //poczty
    fun voivodeshipListRefresh() { /*wojewodztwa*/ }

    fun countyListRefresh(voivodeship: String?) { /*powiaty*/ }

    fun communityListRefresh(county: String?) { /*gminy*/ }

    fun localityListRefresh(community: String?, select: TomTypeahead) { /*miejscowosci*/ }

    fun streetListRefresh(locality: String?, select: TomTypeahead) {/*ulice (stronicowane)*/ }

    private fun addToSelect(singleList: ArrayList<Pair<String, String>>, value: String?) {
        if(value != null && !value.isNullOrEmpty() && !value.isBlank() && !singleList.contains(Pair(value, value))){
            singleList.add(Pair(value, value))
        }
    }

    private fun addToSelect(singleList: ArrayList<String>, value: String?) {
        if(value != null && !value.isNullOrEmpty() && !value.isBlank() && !singleList.contains(value)){
            singleList.add(value)
        }
    }
}
